import type { IGalleryPhoto } from '../constants/sensorGalleryType';

export const getFilteredImages = (images: IGalleryPhoto[], deletedPhotoIds: (number | string)[]) => {
  return images.filter((img) => !deletedPhotoIds.includes(img.id));
};
